import { render } from "./icon-frame.vue?vue&type=template&id=29c26a58"
import script from "./icon-frame.vue?vue&type=script&lang=js"
export * from "./icon-frame.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__